<template>
  <div class="poster_wrap" >
    <div class="middle" >
      <van-swipe class="my-swipe" indicator-color="white" @change="swipeChange" :style="{ visibility: !visible ? '' : 'hidden' }" >
        <van-swipe-item v-for="(item, index) in posterPicVoList" :key="index" >
          <div class="img_wrap" :id="index" >
            <div class="user_wrap" >
              <div>
                <img :src="userVo.headImgUrl" class="head_img" />
                <div>{{userVo.nickName}}</div>
              </div>
              <img :src="qrcode" class="qrcode" v-if="qrcode" />
            </div>
            <img :src="item.pic" class="pic_img" />
          </div>
        </van-swipe-item>
      </van-swipe>
      <div style="display: flex; align-items: center; justify-content: center" >
        <van-button class="poster_btn" :loading="loading" @click="createPoster" >生成海报</van-button>
        <van-button class="poster_btn" @click="home" >返回首页</van-button>
      </div>

    </div>
    <van-popup v-model="visible">
      <img :src="poster" class="poster" />
    </van-popup>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import { getPosterPicVoList, getUserQrCode } from '@/api/poster'
import html2canvas from 'html2canvas'
export default {
  name: 'poster',
  data() {
    return {
      posterPicVoList: [],
      qrcode: '',
      loading: false,
      visible: false,
      index: 0,
      poster: '',
      userVo: JSON.parse(localStorage.getItem('userVo'))
    }
  },
  methods: {
    home() {
      this.$router.push({ name: 'home' })
    },
    get_img (id) {
      const _this = this
      // 生成海报
      html2canvas(id, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          // console.log(doc)
        }
      }).then(function(canvas) {
        // 在微信里,可长按保存或转发
        _this.poster = canvas.toDataURL('image/png')
        _this.visible = true
        _this.loading = false
      })
    },
    createPoster() {
      this.loading = true
      this.get_img(document.getElementById(this.index))
    },
    getPosterPicVoList() {
      getPosterPicVoList({}).then(res => {
        if(res.success) {
          this.posterPicVoList = res.data
        }
      })
    },
    getUserQrCode() {
      getUserQrCode({}).then(res => {
        console.log(res)
        if(res.success) {
          this.qrcode = res.data.buffer
        }
      })
    },
    swipeChange(e) {
      this.index = e
    }
  },
  mounted() {
    this.getPosterPicVoList()
    this.getUserQrCode()
  }
}
</script>
